export default {
  index: {
    title: 'QuantX Risk System'
  },
  route: {
    dashboard: '首页',
    icons: '图标',
    components: '组件',
    componentIndex: '介绍',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: '计数器',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    treeChart: 'GoJs',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    theme: '换肤',
    i18n: '国际化',
    profile: '个人设置',
    systemManager: '系统管理',
    codeManager: '码值管理',
    roleManager: '角色管理',
    userManager: '用户管理',
    menuManager: '菜单管理',
    decisionManager: '决策管理',
    decisionTreeView: '决策树视图',
    decisionTreeManager: '生产决策树配置',
    testDecisionTreeManager: '测试决策树配置',
    decisionTreeRecordView: '决策树记录',
    decisionTreeVersionManager: '决策树版本',
    menuDataEdit: '菜单编辑',
    gradeManager: '评分卡管理',
    gradeCardManager: '生产评分卡配置',
    testGradeCardManager: '测试评分卡配置',
    gradeMappingManager: '评分卡映射配置',
    blacklistManager: '黑名单管理',
    riskResultManager: '风控结果管理',
    DataitemManager: '数据项管理',
    DataitemConfigView: '数据项配置',
    targetManager: '指标管理',
    targetConfigView: '指标配置',
    targetmappingConfigView: '指标映射配置',
    etlConfigView: 'ETL配置',
    prodManager: '产品管理',
    prodConfigView: '生产产品配置',
    testProdConfigView: '测试产品配置',
    merOrderPushDetail: '请求参数',
    prodTestView: '产品测试',
    DyvarConfigView: '动态变量配置',
    blackManager: '黑名单管理',
    blackInfoManager: '黑名单管理',
    blackTypeManager: '黑名单类型管理',
    orderManager: '订单管理',
    merOrderInfoManager: '服务商订单',
    orderInfoManager: '所有订单',
    merOrderInfoDetail: '订单详情',
    merOrderGradeCardDetail: '订单详单',
    merOrderBlacklistDetail: '订单详单',
    merchantInfoManager: '商户管理',
    integrate: '综合',
    system: '系统',
    business: '业务',
    cardVersionManager: '评分卡版本',
    controlManager: '风控开关',
    controlSetView: '开关设置',
    orderQueryView: '处理中订单',
    DeciRuleManager: '规则管理',
    mgtManager: '风控管理',
    paramMng: '进件参数管理',
    productConfig: '产品进件配置',
    productConfigLog: '产品配置日志',
    entranceProduct: '入口产品管理',
    entranceProductLog: '产品管理记录'
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    screenfull: '全屏',
    theme: '换肤',
    size: '布局大小',
    profile: '个人设置'
  },
  login: {
    title: '用户登录',
    logIn: '登录',
    loginName: '账号',
    password: '密码',
    rules: {
      loginName_required: '请输入用户名',
      password_required: '请输入密码'
    }
  },
  // 个人页
  profileInfo: {
    resetPass: {
      resetPassTitle: '重置密码',
      originalPassword: '原始密码',
      currentPassword: '新密码',
      passRule: '至少6位，且必须由数字与字母组成',
      passRuleConsistency: '新旧密码不能一致'
    }
  },
  permission: {
    roles: '你的权限',
    switchRoles: '切换权限'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  components: {
    SysCode: {
      defaultValue: '请选择'
    }
  },
  table: {
    id: 'ID',
    type: '类型',
    date: '时间',
    createdTime: '创建时间',
    lastModifiedTime: '更新时间',
    createdUser: '创建人员',
    lastModifiedUser: '更新操作人',
    status: '状态',
    actions: '操作',
    search: '搜索',
    add: '添加',
    save: '保存',
    export: '导出',
    import: '导入',
    edit: '编辑',
    detail: '详情',
    view: '详情',
    publish: '发布',
    publish_test: '发布至测试树',
    setting: '设置',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    submit: '提交',
    grant: '授权',
    batch: '批量',
    query: '查询',
    reset: '重置',
    locked: '锁定',
    unlocked: '解锁',
    dyFilter: '输入首拼音或名称',
    remark: '备注',
    refresh: '刷新',
    close: '关闭',
    show: '显示',
    version: '版本',
    keyPlaceholder: '输入关键字查询',
    restPassword: '重置密码',
    notNull: '不能为空'
  },
  utils: {
    request: {
      opt_success: '操作成功!',
      logout_confirm_text: '你已被登出，可以取消继续留在该页面，或者重新登录!',
      logout_confirm_title: '确定登出',
      logout_confirm_btn: '重新登录',
      logout_confirm_cancel: '取消'
    },
    clipboard: {
      tips: '点击复制',
      success: '复制成功',
      error: '复制失败'
    }
  },
  views: {
    commons: {
      confirm: {
        remove_text: '确认删除这条记录？',
        ok: '确认进行操作？',
        cancel: '已取消操作'
      },
      message: {
        single_selected: '请选择一条数据进行操作',
        multi_selected: '请至少选择一条数据进行操作'
      },
      codes: {
        yes: '是',
        no: '否'
      }
    },
    system: {
      components: {
        menuSelect: {
          title: '菜单授权'
        },
        roleList: {
          title: '角色选择',
          selectAll: '全选'
        },
        roleSelect: {
          title: '角色授权',
          placeholder: '请选择角色'
        }
      },
      menuManager: {
        filterH2: '菜单目录',
        filterPlaceholder: '输入关键字进行过滤',
        detailH2: '菜单详情',
        addChild: '子菜单',
        update: '更新',
        form: {
          parentMenuId: '上级菜单',
          menuCode: '菜单编码',
          menuName: '菜单名称',
          menuLevel: '菜单级别',
          remark: '备注'
        },
        rules: {
          menuName_required: '菜单名必填',
          menuCode_required: '菜单编码必填'
        },
        append_text: '追加',
        remove_text: '删除',
        message_formOpen_text: '请选择父菜单'
      },
      roleManager: {
        form: {
          roleName: '角色名称',
          roleCode: '角色编码',
          isUse: '是否启用',
          remark: '备注'
        },
        rules: {
          roleName_required: '角色名称必填',
          roleCode_required: '角色编码必填'
        }
      },
      userManager: {
        form: {
          loginName: '用户名',
          userName: '姓名',
          isUse: '是否启用',
          password: '密码',
          merNo: '商户号',
          remark: '备注'
        },
        rules: {
          loginName_required: '用户名必填',
          userName_required: '姓名必填',
          merNo_required: '商户号必选'
        }
      }
    },
    black: {
      blackInfoManager: {
        filter: {
          numberType: '请选择号码类型',
          number: '请输入查询号码',
          typeKey: '请选择黑名单标识',
          typeName: '请输入查询的黑名单类型名称'
        },
        form: {
          numberType: '号码类型',
          number: '号码',
          numberTip: '请输入黑名单号码',
          typeKey: '黑名单类型标识',
          remark: '备注'
        },
        rules: {
          numberType_required: '请选择号码类型',
          number_required: '请输入黑名单号码',
          typeKey_required: '请选择黑名单类型'
        },
        table: {
          numberType: '号码类型',
          number: '号码',
          typeKey: '黑名单类型标识',
          typeName: '黑名单类型名称',
          joinTs: '入黑时间',
          remark: '备注'
        },
        confirm: {
          title: '提示',
          content: '确认删除该条黑名单记录吗？',
          confirm: '确认',
          cancel: '取消'
        }
      },
      blackTypeManager: {
        filter: {
          typeKey: '请输入黑名单类型标识',
          typeName: '请输入黑名单类型名称'
        },
        form: {
          typeKey: '黑名单类型标识',
          typeName: '黑名单类型名称',
          remark: '备注'
        },
        rules: {
          typeKey_required: '黑名单类型标识不能为空',
          typeName_required: '黑名单类型名称不能为空'
        },
        confirm: {
          title: '提示',
          content: '确认删除该条黑名单类型记录吗？删除黑名单类型其对应的黑名单信息也会关联删除！',
          confirm: '确认',
          cancel: '取消'
        }
      }
    },
    decision: {
      decisionTreeManager: {
        action: {
          versions: '版本'
        },
        formData: {
          treeNo: '树编号',
          treeName: '树名称',
          merNo: '商户号',
          treeNoDefault: '不填时，系统自动生成',
          firstNodeNo: '首节点编号',
          treeId: '决策树ID'
        },
        rules: {
          treeNo_required: '名称必填',
          treeNo_unique: '名称已存在',
          treeName_required: '名称必填'
        }
      },
      decisionTreeVersionManager: {
        action: {
          publish: '发布',
          publishRecords: '发布日志',
          invalidRule: '清除无效规则',
          records: '日志'
        },
        dialog: {
          recordsList: '操作日志列表',
          publishRecordsList: '发布日志列表',
          invalidRuleList: '无效规则列表'
        },
        formData: {
          versionNo: '版本编号',
          treeName: '树名称',
          firstNodeId: '首节点',
          title: '版本名称',
          running: '运行中',
          deciName: '规则名称'
        },
        rules: {
          versionNo_required: '版本号必填',
          title_required: '版本号必填'
        }
      },
      decisionTreeView: {
        action: {
          switchVersion: '切换版本'
        },
        label: {
          runningVersion: '运行中版本',
          currentVersion: '当前版本：',
          nodeInfo: '节点信息',
          ruleInfo: '规则信息',
          addRule: '添加规则',
          editRule: '编辑规则',
          editRuleTips: '按下 Ctrl 自动提示',
          submitVersion: '保存当前版本',
          viewMore: '查看更多',
          infoTips: '请点击选择相应节点，规则进行操作。',
          submitLoadingText: '数据提交正在处理，请勿刷新页面',
          loadingText: '正在加载....',
          exitTips: '您有未保存的编辑内容，确定退出吗?',
          openDeciRule: '点击编辑规则'
        },
        message: {
          success: '操作成功',
          fail: '操作失败',
          cancel: '已取消操作',
          error: '请填写正确的信息',
          beforeClose: '确定要离开吗?',
          openSubmitFormDialog: '请先选择树首节点'
        },
        cacheMap: {
          node: '节点',
          deci: '规则',
          added: '新增',
          edited: '编辑',
          removed: '删除'
        },
        formData: {
          id: 'ID',
          title: '版本名称',
          nodeName: '节点名称',
          targetIds: '指标',
          deciName: '规则名称',
          nodeId: '节点ID',
          nextNodeId: '下一节点ID',
          nextNodeName: '下一节点名称',
          merNo: '商户号',
          treeId: '树ID',
          deciRule: '规则内容',
          deciRuleType: '规则类型',
          deciVal: '规则值',
          resultType: '决策处理结果',
          nodeLevel: '节点级别',
          anotherName: '通知标识',
          firstNodeId: '首节点'
        },
        rules: {
          title_required: '版本名称必填',
          title_length: '请输入10个以内字符',
          nodeName_required: '节点名称必填',
          nodeId_required: '节点ID必填',
          deciName_required: '规则名称必填',
          deciVal_required: '规则值必填',
          deciRuleType_required: '规则值类型必填',
          resultType_required: '返回类型必填',
          nodeLevel_required: '节点级别必填',
          anotherName_required: '节点别名必填'
        }
      }
    },
    order: {
      merOrderInfoManager: {
        formData: {
          appNo: 'App no',
          orderNo: '订单编号',
          orderMerNo: '调用商',
          prodNo: '产品编号',
          prodType: '产品类型',
          prodMerNo: '服务商',
          status: '状态',
          uniqueKey: '唯一标识'
        },
        rules: {
          orderNo_required: '订单编号必填'
        }
      },
      merOrderInfoDetail: {
        orderBasic: {
          title: '订单信息'
        },
        recordDiagram: {
          title: '风控轨迹'
        },
        recordData: {
          title: '指标',
          formData: {
            index: '序号',
            name: '名称',
            value: '指标值',
            status: '状态'
          }
        },
        chartOptions: {
          status_1: '待处理',
          status_2: '处理中',
          status_3: '已处理',
          status_4: '失败'
        },
        orderInfo: {
          info: {
            appNo: 'App no',
            orderNo: '订单号',
            orderMerNo: '订单商户号',
            prodNo: '产品编号',
            prodType: '产品类型',
            prodMerNo: '归属商户号',
            status: '状态',
            uniqueKey: '唯一标识'
          },
          result: {
            appNo: 'App no',
            orderNo: '订单号',
            orderMerNo: '订单商户号',
            prodNo: '产品编号',
            prodType: '产品类型',
            prodMerNo: '归属商户号',
            status: '状态',
            uniqueKey: '唯一标识',
            orderResult: '订单结果',
            noticeUrl: '通知地址',
            noticeStatus: '通知状态',
            expireTs: '产品结果到期时间',
            compTs: '订单完成时间'
          }
        }
      },
      merOrderGradeCardDetail: {
        orderInfo: {
          title: '订单信息',
          info: {
            appNo: 'App no',
            orderNo: '订单号',
            orderMerNo: '订单商户号',
            prodNo: '产品编号',
            prodType: '产品类型',
            prodMerNo: '归属商户号',
            status: '状态',
            uniqueKey: '唯一标识',
            remark: '备注'
          },
          result: {
            appNo: 'App no',
            orderNo: '订单号',
            orderMerNo: '订单商户号',
            prodNo: '产品编号',
            prodType: '产品类型',
            prodMerNo: '归属商户号',
            status: '状态',
            uniqueKey: '唯一标识',
            orderResult: '订单结果',
            noticeUrl: '通知地址',
            noticeStatus: '通知状态',
            expireTs: '产品结果到期时间',
            compTs: '订单完成时间',
            remark: '备注'
          }
        },
        recordGradeCard: {
          title: '评分卡信息',
          info: {
            cardId: '评分卡编号',
            cardName: '评分卡名称',
            rule: '指标名称序列',
            sequence: '指标序列值',
            cardVal: '评分值',
            status: '状态',
            remark: '备注'
          }
        },
        recordTarget: {
          title: '关联指标信息',
          formData: {
            targetId: '指标ID',
            targetName: '指标名称',
            targetVal: '指标值',
            status: '状态',
            etlId: 'ETLID',
            etlName: 'ETL名称',
            etlType: 'ETL类型',
            etlPath: 'ETL包路径',
            mapping: '是否映射'
          }
        },
        recordData: {
          title: '指标',
          formData: {
            index: '序号',
            name: '名称',
            value: '指标值',
            status: '状态'
          }
        }
      },
      merOrderBlacklistDetail: {
        orderInfo: {
          title: '订单信息',
          info: {
            appNo: 'App no',
            orderNo: '订单号',
            orderMerNo: '订单商户号',
            prodNo: '产品编号',
            prodType: '产品类型',
            prodMerNo: '归属商户号',
            status: '状态',
            uniqueKey: '唯一标识',
            remark: '备注'
          },
          result: {
            appNo: 'App no',
            orderNo: '订单号',
            orderMerNo: '订单商户号',
            prodNo: '产品编号',
            prodType: '产品类型',
            prodMerNo: '归属商户号',
            status: '状态',
            uniqueKey: '唯一标识',
            orderResult: '订单结果',
            noticeUrl: '通知地址',
            noticeStatus: '通知状态',
            expireTs: '产品结果到期时间',
            compTs: '订单完成时间',
            remark: '备注'
          }
        }
      }
    },
    grade: {
      gradeCardManager: {
        filter: {
          cardName: '请输入评分卡名称',
          rule: '指标名称序列'
        },
        form: {
          title: '版本名称',
          title_running: '运行版本名称',
          versionNo: '版本编号',
          publishStatus: '运行中',
          cardName: '评分卡名称',
          cardNameTips: '请输入评分卡名称',
          boundTitle: '已绑定指标',
          unBoundTitle: '未绑定指标',
          ruleTitle: '指标名称序列：',
          tips1: '操作提示：点击右边「未绑定指标」即可添加到左边「已绑定指标列表」',
          tips2: '注：请核对指标序列规则顺序是否正确！（已绑定指标列表可拖动排序）',
          remark: '备注',
          remarkTips: '填写备注信息',
          boundTarget: '请选择关联指标'
        },
        rules: {
          cardName_required: '评分卡名称不能为空',
          title_required: '版本名称不能为空',
          title_limit_length: '版本名称长度不超过40',
          cardName_limit_length: '评分卡名称长度不超过100',
          remark_limit_length: '评分卡名称长度不超过200'
        },
        table: {
          cardId: '评分卡编号',
          cardName: '评分卡名称',
          rule: '指标名称序列',
          tipMapping: '映射管理'
        },
        confirm: {
          title: '提示',
          content: '确认删除该条评分卡记录吗？删除该评分卡其对应的映射数据也会关联删除！',
          confirm: '确认',
          cancel: '取消'
        }
      },
      gradeMappingManager: {
        filter: {
          cardId: '请选择评分卡',
          val: '请输入评分卡指标映射值',
          rule: '指标名称序列'
        },
        form: {
          cardId: '评分卡',
          cardIdTips: '请选择评分卡',
          rule: '指标名称序列',
          sequence: '指标序列值',
          sequenceTips: '请输入指标序列值（如：1,2,3）',
          val: '指标映射值',
          valTips: '请输入评分卡指标映射值',
          remark: '备注',
          remarkTips: '填写备注信息',
          tips: '特别提示：请仔细核对信息是否正确，且指标序列规则和指标序列值是否吻合？'
        },
        rules: {
          cardId: '请选择评分卡',
          sequence: '请输入指标序列值',
          val: '请输入评分卡指标映射值'
        },
        table: {
          upload: '批量映射导入',
          cardName: '评分卡名称',
          rule: '指标名称序列',
          sequence: '指标序列值',
          val: '指标映射值'
        },
        upload: {
          title: '批量评分卡指标映射导入',
          buttonLabel: '指标序列映射配置',
          button: '上传附件',
          fileName: '批量评分卡映射模版.xlsx',
          download: '点击下载模版',
          uploadTips: '只能上传.xlsx/.xls文件，且不超过2M。',
          tips1: '特别提示：',
          tips2: '评分卡映射批量导入时，会先清空该评分卡下所有映射数据，请确认后再导入！',
          tips3: '请仔细确认导入的Excel文件为该评分卡的全量评分卡映射数据！',
          onExceed: '同时只能导入一个Excel文件',
          excelRequired: '请选择需要到入的Excel文件',
          excelSizeErr: '上传失败！附件大小不能超过2M',
          success: '评分卡批量映射导入成功',
          errorPrefix: '导入失败：'
        },
        confirm: {
          title: '提示',
          content: '确认删除该条评分卡映射数据吗？',
          confirm: '确认',
          cancel: '取消'
        }
      },
      commons: {
        dialog: {
          title: '指标序列规则详情',
          cardName: '评分卡名称：',
          rule: '指标名称序列：'
        }
      }
    },
    merchant: {
      merchantInfoManager: {
        formData: {
          merNo: '商户号',
          shortName: '商户简称',
          fullName: '商户全称',
          levelNo: '等级号',
          enable: '启用',
          merKey: '商户Key',
          appNo: 'AppNo',
          prodNo: '产品编号',
          noticeUrl: '通知地址'
        },
        rules: {
          merNo_required: '商户号必填',
          merNo_unique: '商户号已存在',
          fullName_required: '全称必填',
          shortName_required: '简称必填',
          enable_required: '启用必选',
          appNo_required: 'AppNo必填',
          prodNo_required: '产品必选',
          notify_required: '通知地址必填',
          notify_invalid: '请输入正确的通知地址'
        },
        action: {
          bindApp: '绑定App',
          unBind: '解绑',
          bindProd: '订购产品'
        },
        dialog: {
          bindApp: '绑定App列表',
          bindProd: '订购产品列表'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js